import { useEffect, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { CreateCollaboratorsUseCase } from "../../../Usecase/Collaborators/create-collaborators-usecase";
import { SubmitHandler, useForm } from "react-hook-form";
import { ICollaboratorEntity, ICreateCollaboratorPayload, IUpdateCollaboratorPayload } from "../../../Services/api/collaborators/collaborators.interface";
import { FindKeyWithPrefix } from "../../../utils/findKeyWithPrefix";
import { ICreateCustomerPayload, IUpdateCustomerPayload } from "../../../Services/api/customers/customers.interface";
import { useTheme } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import * as Yup from 'yup'
import { ShowCollaboratorsUseCase } from "../../../Usecase/Collaborators/show-collaborators-usecase";
import { UpdateCollaboratorsUseCase } from "../../../Usecase/Collaborators/update-collaborators-usecase";

interface ICollaboratorProps {
    name: string
    username: string
    permissions: string[]
    [key: `swtich-${string}`]: boolean
}
const CreateCollaboratorSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    username: Yup.string().required('E-mail é obrigatório').email('E-mail inválido')
  });

interface IuseCreateCollaboratorsProps {
  createCollaboratorsUseCase: CreateCollaboratorsUseCase
    showCollaboratorsUseCase: ShowCollaboratorsUseCase
    updateCollaboratorsUseCase: UpdateCollaboratorsUseCase
}
export function useCreateCollaborators({ createCollaboratorsUseCase, showCollaboratorsUseCase, updateCollaboratorsUseCase }: IuseCreateCollaboratorsProps){
    const [loading, setLoading] = useState(false)
   
    const [data, setData] = useState<ICollaboratorEntity>()
  
    const theme = useTheme()
    const navigate = useNavigate()

    const { handleSubmit, register, control, formState, watch, setValue } = useForm<ICollaboratorProps>({
        resolver: yupResolver(CreateCollaboratorSchemaValidation),
      });

      const params = useParams()

      const { errors } = formState

      

    const { showToast } =  useToast()

    const handleAction: SubmitHandler<ICollaboratorProps> = async (values) => {
        const permissions = FindKeyWithPrefix(values, 'swtich-')
        
        // Transform permissions array into the desired format
        const formattedPermissions = permissions
            .filter((permission: { key: string; value: boolean }) => permission.value === true)
            .map((permission: { key: string; value: boolean }) => {
                const key = permission.key.replace('swtich-', '');
                return `${key}:manage`;
            });

            console.log("formattedPermissions: ", formattedPermissions)

        try {
          setLoading(true)

            const payloadCreate: ICreateCollaboratorPayload  = {
              name: values.name,
              username: values.username,
              permissions: ['all'],
              permissionsScreens: formattedPermissions,
            }


            const payloadUpdate: IUpdateCollaboratorPayload  = {
              ...payloadCreate,
              id: String(params.id)
            }
          
          //   const storeResult = params.id ? await updateCustomersUseCase.handle(payloadUpdate) :  await createCustomersUseCase.handle(payloadCreate);
          const storeResult = params.id ? await updateCollaboratorsUseCase.handle(payloadUpdate) : await createCollaboratorsUseCase.handle(payloadCreate)

            if (storeResult.isFailure) {
              
              showToast(String(storeResult?.error?.error), 'error');
              return;
            }

          //   showToast(params.id ? 'Cliente Atualizado' : 'Cliente Cadastrado', 'success')
          showToast(params.id ? 'Colaborador Atualizado' : 'Colaborador Cadastrado', 'success')
          navigate('/collaborators-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };


    
    const menuOptions = [
        {
          label: 'Caixas',
          value: 'menu:boxes',
          type: 'menu',
          features: []
        },
        {
          label: 'Cubagens',
          value: 'menu:cubages',
          type: 'menu',
          features: []
        },
        {
          label: 'Categorias',
          value: 'menu:categories',
          type: 'menu',
          features: []
        },
        {
          label: 'Colaboradores',
          value: 'menu:collaborators',
          type: 'menu',
          features: []
        },
        {
          label: 'Clientes',
          value: 'menu:customers',
          type: 'menu',
          features: []
        },
        {
          label: 'Financeiro',
          value: 'menu:financial',
          type: 'menu',
          features: []
        },
        {
          label: 'Pedidos',
          value: 'menu:orders',
          type: 'menu',
          features: [
            {
              label: 'Cancelar Pedido',
              value: 'feature:orders-cancel'
            },
            {
              label: 'Reprocessar Pedido',
              value: 'feature:orders-reprocess'
            },
            {
              label: 'Lista de Separação',
              value: 'feature:orders-list-separation'
            }
          ]
        },
        {
          label: 'Produtos',
          value: 'menu:products',
          type: 'menu',
          features: []
        },
        {
          label: 'Estoque',
          value: 'menu:stocks',
          type: 'menu',
          features: [
            {
              label: 'Ajustar Estoque Manualmente no Hub',
              value: 'stocks:adjust-manually'
            },
          
          ]
        },
        {
          label: 'Serviços',
          value: 'menu:productsServices',
          type: 'menu',
          features: []
        },
        {
          label: 'Pedidos de Reposição',    
          value: 'menu:replacementOrders',
          type: 'menu',
          features: []
        },
        {
          label: 'Produção',
          value: 'menu:production',
          type: 'menu',
          features: []
        },
        {
          label: 'Vendedores',
          value: 'menu:sellers',
          type: 'menu',
          features: []
        }
      ]

      // Estado para controlar quais menus estão expandidos
      const [expandedMenus, setExpandedMenus] = useState<Record<string, boolean>>({})

      const toggleMenuExpansion = (menuValue: string) => {
        setExpandedMenus(prev => ({
          ...prev,
          [menuValue]: !prev[menuValue]
        }))
      }
  
      
      const loadCollaborator = async (collaboratorId: string) => {
        
        try {
          setLoading(true)
          
          const showResult = await showCollaboratorsUseCase.handle(collaboratorId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const result = showResult.getValue()

         if(result){
            setData(result)

            setValue('name', result.name)
            setValue('username', result.username)

            result?.permissionsScreens?.forEach((permission: string) => {
             
              const parts = permission.split(':')
              const getPermissionKey = parts.slice(0, -1).join(':') // Remove a última parte (:manage)
              setValue(`swtich-${getPermissionKey}`, true)
            })




            
         }

        } catch (error) {
          console.log("error loadCollaborator function: ", error)
        } finally {
          setLoading(false);
        }
      };



      useEffect(() => {
        if(params?.id){
          loadCollaborator(params.id)
        }
      }, [params])
  

      

    return {
        loading,
        handleAction,
        register,
        control,
        formState,
        watch,
        handleSubmit,
        errors,
        menuOptions,
        expandedMenus,
        toggleMenuExpansion,
        
        
        
    }
}